/**
 * Labstep
 *
 * @module components/Signature/Card/EmptyState
 * @desc Empty state for signature
 */

import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { ISignatureEmptyStateProps } from './types';

export const SignatureEmptyState: React.FC<
  ISignatureEmptyStateProps
> = ({ action, explanationText }) => (
  <CardEmptyState
    src="/img/empty-state/signatures.svg"
    explanation={explanationText}
    action={action}
  />
);
